import { styled } from '@mui/material';

export const Main = styled('main')(() => ({
  display: 'grid',
  position: 'relative',
}));
